var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBbond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 500 500",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41022 250.363C5.41022 115.589 114.666 6.33356 249.44 6.33356C384.213 6.33356 493.469 115.589 493.469 250.363C493.469 385.137 384.213 494.392 249.44 494.392C114.666 494.392 5.41022 385.137 5.41022 250.363Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "#aa7d50",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.323 123.606L154.323 177.516C162.171 173.216 169.938 168.763 177.621 164.161L199.963 150.806L224.695 164.652C232.938 169.307 241.182 174.086 249.426 179.108L265.316 188.911L265.316 265.731L257.311 270.632L248.948 275.532C240.943 280.188 232.819 284.844 224.814 289.745L200.68 304.447L168.063 285.09C157.31 278.718 146.319 272.347 135.447 265.731L135.447 186.705L135.566 148.845C135.685 136.226 135.566 124.097 135.447 112.58L135.447 112.089L154.323 123.606ZM200.561 173.228C192.795 177.638 185.029 182.049 177.502 186.705L154.443 200.55L154.443 254.458L177.502 268.059C185.059 272.538 192.586 277.071 200.082 281.658C207.849 277.248 215.615 272.837 223.142 268.181L246.2 254.336L246.2 200.427L223.381 186.827L200.561 173.228Z",
    fill: "#a6a8ab",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "#929497",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M265.555 188.907L265.555 243.061C273.403 238.762 281.17 234.309 288.852 229.706L311.195 216.352L335.926 230.197C344.17 234.853 352.414 239.631 360.658 244.654L376.547 254.456L376.547 331.276L368.543 336.177L360.18 341.079C352.174 345.733 344.051 350.389 336.045 355.291L311.912 369.992L279.295 350.635C268.542 344.264 257.55 337.892 245.722 332.134L245.961 176.9M311.793 238.773C304.026 243.183 296.26 247.595 288.733 252.25L265.674 266.096L265.674 320.005L288.733 333.604C296.291 338.084 303.818 342.618 311.314 347.204C319.08 342.794 326.846 338.383 334.373 333.727L357.431 319.881L357.431 265.973L334.611 252.373L311.793 238.773Z",
    fill: "#2669b1",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbond);
export default __webpack_public_path__ + "static/media/bbond.34256b33cc46664d802dbc7024da6a10.svg";
export { ForwardRef as ReactComponent };